import "@/App.css";

export default function Tools() {
  return (
    <div className="preview" data-testid="preview-root">
      <iframe className="preview-frame" src="/loading/index.html" title="SORA RP Loading Screen" data-testid="preview-iframe" allow="autoplay" />
      <div className="preview-dls">
        <a className="preview-dl" href="/" data-testid="tools-site-link">الموقع</a>
        <a className="preview-dl" href="/sora_loading.zip" download data-testid="download-resource-btn">تحميل sora_loading.zip</a>
        <a className="preview-dl" href="/sora_graphics.zip" download data-testid="download-graphics-btn">تحميل sora_graphics.zip</a>
        <a className="preview-dl" href="/spd/index.html" target="_blank" rel="noreferrer" data-testid="open-spd-preview-btn">معاينة ورشة LSPD</a>
        <a className="preview-dl" href="/sora_playtime.zip" download data-testid="download-playtime-btn">تحميل sora_playtime.zip</a>
        <a className="preview-dl" href="/sora_spd_workshop.zip" download data-testid="download-spd-btn">تحميل sora_spd_workshop.zip</a>
      </div>
    </div>
  );
}
